/**
 * Whether a delivery date's week is inside an allowed-weeks set (Task 12: the
 * allowed-weeks cart constraint). Encodes the unconstrained-vs-unsatisfiable
 * distinction that's central to that task: `allowed === null` means no constraint
 * (every date passes); `allowed === []` means the constraint is real but nothing
 * satisfies it (every date fails); a populated list allows only its own week codes.
 *
 * Pure and DOM-free so it's require()-able in node:test, mirroring
 * assets/cart-open-policy.js. Its only dependency, the format module (slotOf), is itself pure and
 * UMD-exported from assets/delivery-date-format.js -- required directly
 * under node:test, read off window.StockedDeliveryFormat in the browser (theme.liquid
 * loads delivery-date-format.js first).
 */
(function (root, factory) {
  var fmt = (typeof module !== 'undefined' && module.exports)
    ? require('./delivery-date-format.js')
    : root.StockedDeliveryFormat;
  var api = factory(fmt);
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.StockedAllowedWeeks = api;
})(typeof self !== 'undefined' ? self : this, function (fmt) {
  // slotOf never throws (null for a malformed/non-string ISO), and
  // Array#indexOf(null) is a normal, non-throwing lookup -- so a bad `iso` resolves to
  // "not allowed" rather than blowing up. `allowed` holds slots (week codes and/or
  // special-date ISOs); without `config` every date's slot is its week code.
  function isWeekAllowed(iso, allowed, config) {
    if (!allowed) return true;
    return allowed.indexOf(fmt.slotOf(iso, config)) !== -1;
  }

  // Filter picker entries by the cart's allowed slots. Special-date entries
  // (`special === true`) are only ever offered when explicitly allowed: with no
  // constraint (null) they stay hidden rather than passing as "everything".
  function offeredDates(entries, allowed, config) {
    return (Array.isArray(entries) ? entries : []).filter(function (e) {
      if (!e) return false;
      if (e.special === true) return Array.isArray(allowed) && allowed.indexOf(e.iso) !== -1;
      return isWeekAllowed(e.iso, allowed, config);
    });
  }

  return { isWeekAllowed: isWeekAllowed, offeredDates: offeredDates };
});
